<template>

  <div class="uk-card uk-card-default uk-box-shadow-hover-large" cardwrapper>

    <div class='team winner'>
      <div class = 'title-wrapper'>
        <div class="team-icon">
          <img src="../../../assets/images/arena/logos/HAR.png"/>
        </div>
        <div class="team-title">
          HAR Huskies
        </div>
      </div>
      <div class = "score">
          59
        </div>
    </div>

    <div class='team'>
      <div class = 'title-wrapper'>
        <div class="team-icon">
          <img src="../../../assets/images/arena/logos/TSD.png"/>
        </div>
        <span class="team-title">
          TSD Jackrabbits
        </span>
      </div>
        <div class = "score">
          48
        </div>
      </div>
  </div>

</template>

<script>
	export default {
		name: "MatchCard"
	}
</script>

<style lang="less" scoped>


  @import "../../../assets/less/palette.less";
  @import "../../../assets/less/theme.less";


  //this needs to match the settings in Bracket.vue!
  @match-card-width: 240px;
  @match-card-height: 80px;

  [cardwrapper] {
    background-color: @dark-bg!important;
    height: @match-card-height;
    width: @match-card-width;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

  }

  .team {
    max-height: 50px;
    width: 85%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    flex-wrap: nowrap;
    margin: 0 auto;


    &.winner {
      font-weight: bold;
    }


    .title-wrapper {
      display: flex;
      align-items: center;

      .team-title {
        margin-left:  10px;
      }
    }


    .team-title, .score {
      font-size: 14px;
      color: @white;
      font-weight: inherit;
    }



    .team-icon {
      img {
        height: 30px;
      }
    }

  }

  @media (max-width: @breakpoint-small-max) {
  [cardwrapper] {
    width: 100%;
  }
  }



</style>
